let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dNxhW")).then(() => parcelRequire('6zDV7'));